/* x-hotspots.js — Set-Bilder: Hover/Fokus/Tipp auf einen Flakon aktualisiert
   den reservierten Info-Bereich unter dem Bild (kein Popover, nichts ueberdeckt
   Nachbarn). Klick/Tipp fixiert die Auswahl; Escape loest sie. Keine
   Warenkorb-Aktion durch den Hotspot selbst. */
(() => {
  const touch = window.matchMedia('(hover: none)').matches;
  document.querySelectorAll('[data-x-hotset]').forEach((set) => {
    const hotspots = Array.from(set.querySelectorAll('[data-x-hotspot]'));
    const bereich = set.querySelector('[data-x-auswahl]');
    if (!hotspots.length || !bereich) return;
    const leer = bereich.querySelector('[data-x-auswahl-leer]');
    const produkte = Array.from(bereich.querySelectorAll('[data-x-produkt]'));
    let fixiert = null;

    const zeige = (code) => {
      produkte.forEach((p) => { p.hidden = p.dataset.xProdukt !== code; });
      if (leer) leer.hidden = !!code;
      hotspots.forEach((h) => {
        const aktiv = h.dataset.code === code;
        h.classList.toggle('x-hotsets__hotspot--aktiv', aktiv);
        h.setAttribute('aria-pressed', String(aktiv && fixiert === code));
      });
    };

    hotspots.forEach((h) => {
      h.setAttribute('role', 'button');
      h.setAttribute('aria-pressed', 'false');
      h.addEventListener('click', (e) => {
        e.preventDefault();
        fixiert = h.dataset.code;
        zeige(fixiert);
        if (touch) bereich.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
      h.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fixiert = h.dataset.code; zeige(fixiert); }
      });
      if (!touch) {
        h.addEventListener('mouseenter', () => zeige(h.dataset.code));
        h.addEventListener('focus', () => zeige(h.dataset.code));
        h.addEventListener('mouseleave', () => zeige(fixiert));
        h.addEventListener('blur', () => zeige(fixiert));
      }
    });
    set.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && fixiert) { fixiert = null; zeige(null); }
    });
  });
})();
